import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { createDocumentForm } from '~/store/actions/documents'
import type { Document, DocumentElementStateItem } from '~/types'

import { DocumentDetailsNew } from './DocumentDetailsNew'
import { removeIdsFromDocument } from './utils'

interface DocumentCloningLocationState {
  state: {
    cloneData: {
      initialDocumentElements: Record<string, DocumentElementStateItem>
      initialDocumentElementsList: string[]
      initialPageList: string[]
      newDocument: Document
    }
  }
}

interface DocumentCloningProps {
  onClose: () => void
}

export const DocumentCloning = ({ onClose }: DocumentCloningProps) => {
  const location = useLocation() as DocumentCloningLocationState
  const dispatch = useDispatch()

  const { t } = useTranslation('Common')

  const { cloneData } = location.state || {}
  // eslint-disable-next-line react/hook-use-state
  const [data] = useState(cloneData)
  const [hasUnsavedData, setHasUnsavedData] = useState(true)
  if (!data) return null

  const handleSave = (doc: Document) => {
    // Remove IDs from document elements and their options when cloning a document
    // to prevent "detached entity passed to persist" errors
    const updatedDocument = removeIdsFromDocument(doc)

    setHasUnsavedData(false)
    dispatch(createDocumentForm(updatedDocument))
  }

  return (
    <DocumentDetailsNew
      disableClone
      disableDelete
      document={data.newDocument}
      hasUnsavedData={hasUnsavedData}
      initialDocumentElements={data.initialDocumentElements}
      initialDocumentElementsList={data.initialDocumentElementsList}
      initialPageList={data.initialPageList}
      saveButtonLabel={t('Common:CREATE_FORM')}
      onClose={onClose}
      onSave={handleSave}
    />
  )
}
